import { env } from '../env/env';
export const adobeAnalyticsConfig = {
    ADOBE_ANALYTICS_URL: env.getString('ADOBE_ANALYTICS_URL') ||
        '//assets.adobedtm.com/348995220a3c/77f7437e78d4/launch-ea7f8516f48b-development.min.js',
};
//# sourceMappingURL=adobeAnalyticsConfig.js.map